import Vue from "vue";
import Vuex from "vuex";
import sqlData from "./sqlData";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    MenuStatus: false,
    Menu: [],
    Intranet: false, // 内网环境true
    requestHeader: "VUEHttpRequest",
    wsUrl: "",
    userInfo: null,
    userGroup: null,
    jumpToPath: null,
    jumpToExecute: "",
    pkgList: [],
    jobSearchName: "",
    zeppelinUrl: "",
    zeppelinTimer: "",
    loginForm: null
  },
  mutations: {
    SET_MENU_STATE(state, bool) {
      state.MenuStatus = bool;
    },
    SET_MENU(state, data) {
      state.Menu = data;
    },
    SET_USER_INFO(state, data) {
      state.userInfo = data;
    },
    SET_USER_GROUP(state, data) {
      state.userGroup = data;
    },
    SET_JUMP_PATH(state, path) {
      state.jumpToPath = path;
    },
    SET_EXECUTE(state, data) {
      state.jumpToExecute = data;
    },
    SET_PKGLIST(state, list) {
      state.pkgList = list;
    },
    SET_JOB_SEARCH_NAME(state, data) {
      state.jobSearchName = data;
    },
    SET_WSURL(state, url) {
      state.wsUrl = url;
    },
    SET_ZEPPELIN_URL(state, url) {
      state.zeppelinUrl = url;
    },
    SET_LOGIN_FORM(state, form) {
      state.loginForm = form;
    },
    SET_ZEPPELIN_TIMMER(state, timer) {
      state.zeppelinTimer = timer;
    }
  },
  actions: {
    setMenuState({ commit }, bool) {
      commit("SET_MENU_STATE", bool);
    },
    setMenu({ commit }, data) {
      commit("SET_MENU", data);
    },
    setUserInfo({ commit }, data) {
      commit("SET_USER_INFO", data);
    },
    setGroup({ commit }, data) {
      commit("SET_USER_GROUP", data);
    },
    setJumpPath({ commit }, path) {
      commit("SET_JUMP_PATH", path);
    },
    setExecute({ commit }, data) {
      commit("SET_EXECUTE", data);
    },
    setpkgList({ commit }, list) {
      commit("SET_PKGLIST", list);
    },
    setSerachName({ commit }, data) {
      commit("SET_JOB_SEARCH_NAME", data);
    },
    setWsurl({ commit }, url) {
      commit("SET_WSURL", url);
    },
    setZeppelinUrl({ commit }, url) {
      commit("SET_ZEPPELIN_URL", url);
    },
    setColor({ state, commit }, data) {
      let userInfo = Object.assign({}, state.userInfo, { colorScale: data });
      commit("SET_USER_INFO", userInfo);
      localStorage.userInfo = JSON.stringify(userInfo);
    },
    setLoginForm({ commit }, form) {
      commit("SET_LOGIN_FORM", form);
    },
    setZeppelinTimer({ commit }, timer) {
      commit("SET_ZEPPELIN_TIMMER", timer);
    }
  },
  modules: {
    sqlData
  }
});
